import { render } from "./CreateBoardGamePage.vue?vue&type=template&id=b0d4c156&scoped=true"
import script from "./CreateBoardGamePage.vue?vue&type=script&lang=js"
export * from "./CreateBoardGamePage.vue?vue&type=script&lang=js"

import "./CreateBoardGamePage.vue?vue&type=style&index=0&id=b0d4c156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d4c156"]])

export default __exports__